<div class="wrapper bi-box-with-borders with-shadow" @fadeInOut>
  <label for="meters" class="FieldLabel" translate>messages.sendByMap.SpecifyWidth</label>
  <p-inputNumber
    inputId="meters"
    inputStyleClass="w-3"
    [(ngModel)]="meters"
    [min]="1"
    [minlength]="1"
    [max]="1000"
    [suffix]="' ' + ('shared.Meters' | translate)"
    (onInput)="onMetersChanged.emit($any($event.value))"
  />
  <p-slider class="block mt-4 w-12" [(ngModel)]="meters" [min]="1" [max]="1000" [step]="1" (onChange)="onMetersChanged.emit($event.value)" />

  <button pButton class="mt-3" [label]="'shared.OK' | translate" [disabled]="meters === 0" (click)="onOkClick.emit()"></button>
</div>
